import { getReportCampaigns } from '@/services/atosa-tiktok-ads/reporting'
import paginationDataMixin from '@/plugins/mixins/pagination-data'
import moment from 'moment'

export default {
    mixins: [paginationDataMixin],

    props: [
        'name_filtering',
        'filtering',
        'multiple_selection',
        'handle_select_row',
        'current_package',
        'type',
        'currency',
        'tiktok_account_id',
        'compare_ranger_date',
        'ranger_date',
        'belong_to_atosa',
        'has_auto_ads',
        'has_manager_ads',
        'has_report_ads',
        'current_balance',
        'advertiser_id'
    ],

    data() {
        return {
            m__filtering: [],
            m__type: '',
            m__order_field: '',
            m__order_type: 'DESC', // DESC , ASC
            m__switch_auto_refresh: false,
            m__performance_column_values: [],
            polling: null
        }
    },

    computed: {
        m__selected_columns() {
            const temp = []
            this.m__performance_column_values.forEach((item) => {
                temp.push(...item.child_values)
            })
            return temp.length
                ? temp
                : [
                      'spend',
                      'cpc',
                      'cpm',
                      'impressions',
                      'clicks',
                      'ctr',
                      'conversion',
                      'cost_per_conversion',
                      'conversion_rate'
                  ]
        }
    },

    watch: {
        m__performance_column_values() {
            this.m__page_info.page = 1
            this.m__getReportCampaignsByAccount()
        },

        advertiser_id() {
            this.m__page_info.page = 1
            this.m__getReportCampaignsByAccount()
        },

        ranger_date() {
            this.m__page_info.page = 1
            this.m__getReportCampaignsByAccount()
        },

        compare_ranger_date() {
            this.m__page_info.page = 1
            this.m__getReportCampaignsByAccount()
        },

        m__selected_columns() {
            localStorage.setItem(
                `performance_column_values_${this.m__type}`,
                JSON.stringify(this.m__performance_column_values)
            )

            this.m__page_info.page = 1
            this.m__getReportCampaignsByAccount()
        },

        filtering() {
            this.m__page_info.page = 1
            this.m__filtering = [...this.filtering]
            this.m__getReportCampaignsByAccount()
        },

        name_filtering() {
            this.m__page_info.page = 1
            this.m__getReportCampaignsByAccount()
        },

        type() {
            if (this.m__type !== this.type) {
                clearInterval(this.polling)
            } else {
                this.m__handleToggleAutoRefresh()
            }
        }
    },

    methods: {
        m__getContentWidthColumn(column) {
            if (
                ['result', 'cost_per_result', 'result_rate'].some(
                    (item) => item === column
                )
            ) {
                return `260px`
            }
            return '180px'
        },

        async m__getReportCampaignsByAccount() {
            if (
                !this.m__type ||
                !this.advertiser_id ||
                !this.tiktok_account_id
            ) {
                return
            }
            this.m__loading = true

            try {
                let filtering = [...this.m__filtering]
                if (this.m__type === 'campaign_id') {
                    filtering = filtering.filter((item) =>
                        ['adgroup_status', 'ad_status'].every(
                            (i) => i !== item.field_name
                        )
                    )
                } else if (this.m__type === 'adgroup_id') {
                    filtering = filtering.filter((item) =>
                        ['campaign_status', 'ad_status'].every(
                            (i) => i !== item.field_name
                        )
                    )
                } else if (this.m__type === 'ad_id') {
                    filtering = filtering.filter((item) =>
                        ['campaign_status', 'adgroup_status'].every(
                            (i) => i !== item.field_name
                        )
                    )
                }

                let temp = {
                    order_field: this.m__order_field,
                    order_type: this.m__order_type,
                    page_size: this.m__page_info.page_size,
                    page: this.m__page_info.page,
                    advertiser_id: this.advertiser_id,
                    type: this.m__type,
                    report_type: 'BASIC',
                    start_date: this.ranger_date[0],
                    end_date: this.ranger_date[1],
                    filtering: JSON.stringify(filtering),
                    metrics: JSON.stringify(this.m__selected_columns)
                }

                if (this.name_filtering) {
                    temp = {
                        ...temp,
                        name_filtering: this.name_filtering
                    }
                }

                const response = await getReportCampaigns(
                    this.tiktok_account_id,
                    temp
                )

                if (response.code === 0) {
                    this.m__data_for_pagination = response.data.list
                    this.m__page_info.total_number =
                        response.data.page_info.total_number
                    this.m__page_info.total_page =
                        response.data.page_info.total_page

                    if (this.compare_ranger_date) {
                        let temp = {
                            order_field: this.m__order_field,
                            order_type: this.m__order_type,
                            page_size: this.m__page_info.page_size,
                            page: this.m__page_info.page,
                            advertiser_id: this.advertiser_id,
                            type: this.m__type,
                            report_type: 'BASIC',
                            start_date: this.compare_ranger_date[0],
                            end_date: this.compare_ranger_date[1],
                            filtering: JSON.stringify(filtering),
                            metrics: JSON.stringify(this.m__selected_columns)
                        }

                        if (this.name_filtering) {
                            temp = {
                                ...temp,
                                name_filtering: this.name_filtering
                            }
                        }

                        const response_compare_range_date =
                            await getReportCampaigns(
                                this.tiktok_account_id,
                                temp
                            )

                        const list_compare =
                            response_compare_range_date.data.list

                        this.m__data_for_pagination =
                            this.m__data_for_pagination.map((item, index) => {
                                return {
                                    ...item,
                                    compare: list_compare[index]
                                }
                            })
                    }

                    if (this.m__type === 'campaign_id') {
                        this.fetchConfigAds()
                        // this.fetchConfigAdsLives()
                    } else if (this.m__type === 'adgroup_id') {
                        this.m__data_for_pagination =
                            this.m__data_for_pagination.map((item) => {
                                const schedule_start_time = moment()
                                    .add(1, 'days')
                                    .format(this.p__format_schedule_tiktok_time)

                                const schedule_end_time = moment()
                                    .add(31, 'days')
                                    .format(this.p__format_schedule_tiktok_time)

                                return {
                                    ...item,
                                    schedule_start_time,
                                    schedule_end_time
                                }
                            })
                    }
                }
            } catch (error) {
                console.error(error)
            }

            this.m__loading = false
        },

        m__formatterColumn(value, column_property, currency) {
            if (
                [
                    'cpc',
                    'cpm',
                    'spend',
                    'cost_per_conversion',
                    'cost_per_result',
                    'real_time_cost_per_conversion',
                    'real_time_cost_per_result',
                    'cost_per_1000_reached',
                    'bid_price',
                    'conversion_bid_price',
                    'adgroup.conversion_bid_price'
                ].some((item) => item === column_property)
            ) {
                return this.p__renderMoneyByCurrency(value, currency)
            }

            if (
                ['impressions', 'clicks', 'conversion'].some(
                    (item) => item === column_property
                )
            ) {
                return this.p__formatNumberHasCommas(value)
            }

            if (
                [
                    'ctr',
                    'result_rate',
                    'conversion_rate',
                    'real_time_conversion_rate',
                    'real_time_result_rate',
                    'profile_visits_rate',
                    'anchor_click_rate',
                    'ix_page_viewrate_avg',
                    'engagement_rate'
                ].some((item) => item === column_property)
            ) {
                return `${value}%`
            }

            return value
        },

        m__getSummaries(param) {
            const { columns, data } = param
            const sums = []
            columns.forEach((column, index) => {
                if (index === 2) {
                    let name_translate = 'campaign'
                    if (this.m__type === 'adgroup_id') {
                        name_translate = 'adgroup'
                    } else if (this.m__type === 'ad_id') {
                        name_translate = 'ad'
                    }

                    sums[index] = `${this.$t('common.total')} \n ${
                        this.m__page_info.total_number
                    } ${this.$t('common.xxx_has_plural_noun', {
                        xxx: this.$t(`common.${name_translate}`)
                    })}`
                    return
                }
                const values = data.map((item) => Number(item[column.property]))
                if (!values.every((value) => isNaN(value))) {
                    let total = this.calculateValue(
                        values,
                        column.property,
                        data
                    )
                    if (
                        this.compare_ranger_date &&
                        data.every((item) => item.compare)
                    ) {
                        const compare_values = data.map((item) =>
                            Number(item[`compare`][column.property])
                        )
                        if (!compare_values.every((value) => isNaN(value))) {
                            const total_calculate = this.calculateValue(
                                compare_values,
                                column.property,
                                data
                            )

                            total += `\n ${total_calculate}`
                        }
                    }

                    sums[index] = total
                } else {
                    sums[index] = ''
                }
            })

            return sums
        },

        calculateValue(values, column_property, data) {
            if (
                [
                    'result',
                    'cost_per_result',
                    'real_time_result',
                    'result_rate',
                    'real_time_cost_per_result',
                    'real_time_result_rate'
                ].some((item) => item === column_property)
            ) {
                return '-'
            }

            let total = values.reduce((prev, curr) => {
                const value = Number(curr)
                if (!isNaN(value)) {
                    return prev + curr
                } else {
                    return prev
                }
            }, 0)

            if (
                [
                    'cpc',
                    'cpm',
                    'cost_per_conversion',
                    'real_time_cost_per_conversion',
                    'cost_per_1000_reached'
                ].some((item) => column_property === item)
            ) {
                const length = data.filter(
                    (item) => Number(item[column_property]) > 0
                ).length
                if (length === 0) {
                    total = this.p__renderMoneyByCurrency(0, data[0].currency)
                } else {
                    total = this.p__renderMoneyByCurrency(
                        total / length,
                        data[0].currency
                    )
                }
            } else if (
                ['impressions', 'clicks', 'conversion', 'reach'].some(
                    (item) => column_property === item
                )
            ) {
                total = this.p__formatNumberHasCommas(total)
            } else if (
                ['ctr', 'conversion_rate', 'real_time_conversion_rate'].some(
                    (item) => column_property === item
                )
            ) {
                const length = data.filter(
                    (item) => Number(item[column_property]) > 0
                ).length

                if (length === 0) {
                    total = `0%`
                } else {
                    total = `${(total / length).toFixed(2)}%`
                }
            } else if (['spend'].some((item) => column_property === item)) {
                total = this.p__renderMoneyByCurrency(total, data[0].currency)
            } else if (['frequency'].some((item) => column_property === item)) {
                const length = data.filter(
                    (item) => Number(item[column_property]) > 0
                ).length
                total = `${(total / length).toFixed(2)}`
            }

            return total
        },

        m__handleToggleAutoRefresh() {
            if (this.m__switch_auto_refresh) {
                this.polling = setInterval(() => {
                    this.m__getReportCampaignsByAccount()
                }, 20e3)
            } else {
                clearInterval(this.polling)
            }
        },

        async m__handleSortChange({ column, prop, order }) {
            this.m__order_field = prop
            this.order_type = order === 'descending' ? 'DESC' : 'ASC'

            this.m__getReportCampaignsByAccount()
        }
    },

    beforeDestroy() {
        clearInterval(this.polling)
    }
}
